<template>
  <usertables
    :section="'photo'"
    :title="'Photo'"
  >
  </usertables>
</template>

<script>
  import Usertables from './userTables'
  export default {
    name: 'Photo',
    components: {Usertables}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user-class/photo.vue